export default __webpack_public_path__ + "edc141bbdcd164d76fccd6a6d724fd53.png";